import { RESET_ACTIVITY_COUNTER } from '../types';

export default (state = {}, action) => {
  switch (action.type) {
    case RESET_ACTIVITY_COUNTER:
      return {
        ...state,
        time: Date.now()
      };

    default:
      return state;
  }
};
